"use strict";

exports.__esModule = true;
exports.PerformanceParameterValueWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _PerformanceParameterValueElement = require("./PerformanceParameterValueElement");
var _PerformanceParameterValueFields = require("./PerformanceParameterValueFields");
var _PerformanceParameterValueHeader = require("./PerformanceParameterValueHeader");
var _PerformanceParameterValueThumbnail = require("./PerformanceParameterValueThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PerformanceParameterValueWidget = exports.PerformanceParameterValueWidget = {
  name: "PerformanceParameterValue",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "PerformanceParameterValueWidget.label",
    defaultMessage: "Realtime Data Item"
  }),
  group: _widgetGroups.RAW_DATA_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "PerformanceParameterValue",
      props: Object.assign({
        width: 256,
        height: 64,
        flex: 1,
        dataItemIndex: 0
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "dataItemIndex"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  icon: "label",
  components: {
    Header: _PerformanceParameterValueHeader.PerformanceParameterValueHeader,
    Element: _PerformanceParameterValueElement.PerformanceParameterValueElement,
    Fields: _PerformanceParameterValueFields.PerformanceParameterValueFields,
    Thumbnail: _PerformanceParameterValueThumbnail.PerformanceParameterValueThumbnail
  }
};